// Module
var code = "<div class=\"action-group\" style=\"z-index:1\"> <div class=\"link-bar\"> <button download download-page=\"downloadOptions.downloadPage\" filter=\"downloadOptions.filter\"></button> <button print ng-disabled=\"!canPrint()\"></button> </div> </div> ";
// Exports
module.exports = code;